import React from 'react'
import cx from 'classnames'

import { Row } from 'components/_new/layout'
import Chip, { ChipProps } from '../Chip/Chip'

import s from './ChipList.scss'


type ChipListItem = ChipProps & {
  key?: number | string
}

type ChipListProps = {
  items?: ChipListItem[]
  dataTestId?: string
}

const ChipList: React.FunctionComponent<ChipListProps> = (props) => {
  const { items, children, dataTestId } = props

  return (
    <Row justify="start" align="start" wrap dataTestId={dataTestId}>
      {
        Boolean(items) && (
          items.map(({ key, className, ...item }, index) => (
            <Chip
              key={key || index}
              className={cx(s.item, className)}
              {...item}
            />
          ))
        )
      }
      {
        React.Children.map(children, (child) => {
          if (!React.isValidElement(child)) {
            return child
          }

          return React.cloneElement(child, {
            className: cx(s.item, child.props.className),
          })
        })
      }
    </Row>
  )
}


export default ChipList
